export default function removeSpecialChars(text) {
    // Expresión regular que detecta símbolos y emojis (caracteres fuera del rango ASCII)
    return text.replace(/[^a-zA-Z0-9áéíóúÁÉÍÓÚñÑ() \-.,[\]{}:;!#$%&/=*+'"?¿`´``]/g, '')
}